export const cardItemsInitial = [
    {
        titlePath: "navigation.adminReworks.title",
        titleConst: "adminReworks",
        descriptionPath: "navigation.adminReworks.description",
        link: "adminRoot",
        color: "red darken-3",
        role: ["admin", "edudept", "adminnb"],
    },
];